import React, { useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import { Container } from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIgetSyncedCollections } from '../api/Collections';

import AdminHeader from '../components/Admin/Header';
import AdminFooter from '../components/Admin/Footer';
import SyncedCollectionsList from '../components/SyncedCollections/List';

import ErrorBoundary from '../components/ErrorBoundary';
import Loading from '../components/Loading';

import { getVisibleItemsText } from '../helpers';

const SyncedCollections = () => {
  const intl = useIntl();

  const [collections, setCollections] = useState([]);
  const [collectionsTotal, setCollectionsTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const perPage = 15;

  const loadSyncedCollections = useCallback(() => {
    setLoading(true);
    APIgetSyncedCollections({ page, per_page: perPage }).then((response) => {
      setCollections(response.data.data);
      setCollectionsTotal(response.data.meta.total);
      setLoading(false);
    });
  }, [page]);

  useEffect(() => {
    loadSyncedCollections();
  }, [page, loadSyncedCollections]);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  return (
    <div className={classnames('main-content')}>
      <Container fluid>
        <AdminHeader
          title={intl.formatMessage({ defaultMessage: 'Synced Collections' })}
          icon="fa-rotate"
          itemName="synced collection"
          itemsTotal={collectionsTotal}
          itemsVisible={getVisibleItemsText(page, perPage, collectionsTotal)}
          showNewItemButton={false}
          loading={loading}
        />
        {loading ? (
          <Loading />
        ) : (
          <ErrorBoundary>
            <div className="content-wrapper">
              <SyncedCollectionsList
                collections={collections}
                loadSyncedCollections={loadSyncedCollections}
              />
            </div>
          </ErrorBoundary>
        )}
        <AdminFooter
          itemsTotal={collectionsTotal}
          page={page}
          perPage={perPage}
          handleChangePage={handleChangePage}
        />
      </Container>
    </div>
  );
};

export default SyncedCollections;
